import aauMin from 'assets/icons/aau.min.webp';
import fandm from 'assets/icons/fandmw.png';
import head from 'assets/icons/theheadstarterlogo.jpg';
import cfp from 'assets/icons/codeforphilly.jpg';
import phlask from 'assets/icons/phlask_logo.jpg';
import codepath from 'assets/icons/codepathorglogo.jpg';
import springer from 'assets/icons/springer-.png';
import yfs from 'assets/icons/yfs.png';
import deendev from 'assets/icons/deen_developers_logo.jpg';
import deenen from 'assets/icons/deenengineers.jpg';
import cares from 'assets/icons/careslab.png';
import binfin8 from 'assets/icons/binfin8.jpeg';
import referi from 'assets/icons/referi.jpg';
import dips from 'assets/icons/dips-logo.png';
import fraunhofer from 'assets/icons/fraunhofer.jpeg';

const details = {
  name: {
    first: 'Ibrahem',
    last: 'Ali',
    nickname: 'ibra-heem',
  },
  education: [
    {
      school: 'Franklin & Marshall College',
      url: 'https://www.fandm.edu',
      icon: fandm,
      iconMin: aauMin,
      location: 'Lancaster, PA, US',
      degree: 'B.A.',
      major: 'Computer Science and Data Science (Double Major)',
      start: 'Aug 2023',
      end: 'May 2027',
    },
    {
      school: 'Sharqia STEM School',
      url: 'https://sharkyastemschool.org',
      location: 'Zagazig, Egypt',
      degree: 'HS (Hons) Diploma',
      major: 'STEM',
      start: 'Sep 2020',
      end: 'Jul 2023',
    },
  ],
  experience: [
    {
      company: 'Fraunhofer IEM',
      url: 'https://www.iem.fraunhofer.de/en.html',
      icon: fraunhofer,
      iconMin: aauMin,
      location: 'Paderborn, NRW, Germany',
      contract: 'Internship',
      position: 'AI Engineer',
      start: 'May 2025',
      end: 'Aug 2025',
      description: [
      ],
      skills: [
        'Multi-Agent Orchestration',
        'LangGraph',
        'System Design',
        'RAG',
        'FastAPI',
        'Docker',
        'Go',
        'PostgreSQL',
        'Typescript with Vue3',
        'LLM Observability and Evaluation',
      ],
    },
    {
      company: 'Binfin8',
      url: 'https://binfin8.com',
      icon: binfin8,
      iconMin: aauMin,
      location: 'San Francisco, CA',
      contract: 'Part-Time',
      position: 'AI Engineer',
      start: 'Sep 2025',
      end: 'Dec 2025',
      description: [
      ],
      skills: [
        'AI Agents',
        'RAG',
        'VectorDB',
        'FastAPI',
        'Docker',
        'Flutter',
      ],
    },
    {
      company: 'Binfin8',
      url: 'https://binfin8.com',
      icon: binfin8,
      iconMin: aauMin,
      location: 'San Francisco, CA',
      contract: 'Internship',
      position: 'AI Engineer',
      start: 'Jun 2025',
      end: 'Aug 2025',
      description: [
      ],
      skills: [
        'AI Agents',
        'PyTorch',
        'Transformers',
        'FastAPI',
        'Docker',
        'Flutter',
        'Firebase',
      ],
    },
    {
      company: 'F&M CARES Lab',
      url: 'https://fandm-cares.github.io',
      icon: cares,
      iconMin: aauMin,
      location: 'Lancaster, PA',
      contract: 'REU',
      position: 'AI Engineer and Researcher',
      start: 'May 2025',
      end: 'Jun 2025',
      description: [
      ],
      skills: [
        'Symbolic AI',
        'Qualitative Reasoning ~ QPT',
        'Dynamic System Modeling',
        'Python',
        'Atomic Physics',
      ],

    },
    {
      company: 'YFS Strategic Holdings, LLC',
      icon: yfs,
      iconMin: aauMin,
      location: 'Lancaster, PA',
      contract: 'Contractor',
      position: 'Software Engineer',
      start: 'Oct 2024',
      end: 'Dec 2024',
      description: [
      ],
      skills: [
        'React',
        'MongoDB',
        'Pyhton',
        'R',
        'Node.js',
        'TensorFlow',
      ],
    },
    {
      company: 'Springer Capital, LLC',
      icon: springer,
      iconMin: aauMin,
      location: 'Chicago, Il',
      contract: 'Internship',
      position: 'Software Engineer',
      start: 'Jun 2024',
      end: 'Nov 2024',
      description: [
      ],
      skills: [
        'Python',
        'React',
        'Tailwind CSS',
        'Node.js',
        'Power Automate',
        'Power Bi',
        'NLTK',
      ],
    },
  ],
  languages: [
    {
      name: 'Arabic',
      level: 'C2',
      native: true,
    },
    {
      name: 'English',
      level: 'C1',
    },
    {
      name: 'German',
      level: 'A2',
    },
  ],
  contact: {
    address: 'pennsylvania',
    email: 'iali [at] fandm.edu',
    phone: '(223) 207 4118',
    website: 'https://ibraheem.xyz',
    linkedin: 'https://www.linkedin.com/in/ibrahemalii',
    github: 'https://www.github.com/iibrahemali',
    researchgate: 'https://www.researchgate.net/profile/Ibrahem-Ali-2',
    gitlab: 'https://gitlab.com/iibrahemali1',
    kaggle: 'https://www.kaggle.com/ibrahemali1',
    leetcode: 'https://leetcode.com/u/ibrahemali/',
  },
  communityops: [
    {
      organization: 'Code for Philly - Balancer',
      url: 'https://balancerproject.com/',
      icon: cfp,
      iconMin: aauMin,
      location: 'Remote',
      position: 'Software Developer',
      start: 'Jun 2024',
      end: 'Present',
      description: 'Balancer: AI-powered Bipolar Medication Decision Support App',
      skills: [
        'Python',
        'React',
        'Django',
        'PostgreSQL',
      ],
    },
    {
      organization: 'Code for Philly - PHLask',
      url: 'https://phlask.me/',
      icon: phlask,
      iconMin: aauMin,
      location: 'Remote',
      position: 'Software Developer',
      start: 'Jun 2024',
      end: 'Present',
      description: 'PHLASK: An Ecosystem For Finding and Sharing Resources in Philadelphia',
      skills: [
        'Python',
        'HTML/CSS',
        'Keras',
        'Flask',
      ],
    },
  ],
  // coursework - color can be MUI color name or hex color
  coursework: [
    { name: 'Computer Architecture', color: 'primary', instructor: 'Ed Novak' },
    { name: 'Computer Networks', color: 'primary', instructor: 'Brad McDanel' },
    { name: 'Machine Learning', color: 'primary', instructor: 'Emily Jensen' },
    { name: 'Deep Learning & Gen AI', color: 'primary', instructor: 'Brad McDanel' },
    { name: 'Natural Language Processing', color: 'primary', instructor: 'Brad McDanel' },
    { name: 'Parallel Computing', color: 'primary', instructor: 'Brad McDanel' },
    { name: 'Data Structures & OOP', color: 'primary', instructor: 'Gerald Tompkins' },
    { name: 'Advanced Data Structures & Algorithms', color: 'primary', instructor: 'Jing Hu' },
    { name: 'Advanced Algorithms Design', color: 'primary', instructor: 'Jing Hu' },
    { name: 'Mobile App Dev', color: 'primary', instructor: 'Ed Novak' },
    { name: 'Probability & Statistics', color: 'info', instructor: 'Danel Draguljic' },
    { name: 'Calculus I, II & III', color: 'info', instructor: 'Hull, Weaver, McCooey' },
    { name: 'Linear Algebra & Modern Applications', color: 'info', instructor: 'Tom Hull' },
    { name: 'Theory of Computation', color: 'info', instructor: 'Justin Brody' },
    { name: 'Comp Discrete Math', color: 'info', instructor: 'Justin Brody' },
    { name: 'Symbolic/Math Logic', color: 'info', instructor: 'Nick Kroll' },
  ],
  // research Assistantships
  researchAssistantships: [
    { name: 'Symbolic AI for Atomic Physics, Prof. Jason R. Wilson', color: 'neutral' },
    { name: 'Deep Learning for Biomedicine, Prof. Jing Hu', color: 'neutral' },
  ],
  affiliations: [
    {
      organization: 'Franklin & Marshall',
      url: 'https://fandm.edu/',
      icon: dips,
      iconMin: aauMin,
      role: 'Student Worker',
    },
    {
      organization: 'Headstarter AI',
      url: 'https://headstarter.co/',
      icon: head,
      iconMin: aauMin,
      role: 'SWE Fellow',
    },
    {
      organization: 'CodePath',
      url: 'https://www.codepath.org/',
      icon: codepath,
      iconMin: aauMin,
      role: 'SWE Student & Member',
    },
    {
      organization: 'Deen Developers',
      url: 'https://www.deendevelopers.com/',
      icon: deendev,
      iconMin: aauMin,
      role: 'Team Member',
      start: 'Jan 2024',
      end: 'Present',
    },
    {
      organization: 'Deengineers',
      url: 'https://www.deengineers.co.uk/',
      icon: deenen,
      iconMin: aauMin,
      role: 'Team Member',
    },
    {
      organization: 'Referi',
      url: 'https://www.referi.io',
      icon: referi,
      iconMin: aauMin,
      role: 'X-Culture R&D',
    },
  ],
};

export default details;
